import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { NavLinkI } from './getNavLinks'

type SideNavLinkProps = {
  route: NavLinkI
}
export const NavLink = ({ route }: SideNavLinkProps) => {
  const location = useLocation()
  const isActive = !route.externalLink && location.pathname.includes(route.url)

  const inner = (
    <>
      <i
        style={{ color: !isActive ? '#a2a3b7' : '#a044ff' }}
        className={`fad w-8 text-center fa-${route.icon}`}
      />
      <span
        style={{ color: !isActive ? '#a2a3b7' : '#a044ff' }}
        className="flex-grow text-lg sm:text-sm"
      >
        {route.label}
      </span>
    </>
  )

  const className = `menu-link space-y-2 p-3 flex justify-items-stretch justify-center rounded-md items-center flex-col ${
    isActive ? 'border-1 border-white rounded-md bg-gray-50' : ''
  }`

  return (
    <li className={'flex flex-col justify-center items-center w-full hover:bg-gray-700 p-1'}>
      {route.externalLink ? (
        <a
          href={route.externalLink}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
        >
          {inner}
        </a>
      ) : (
        <Link to={`/${route.url}`} className={className}>
          {inner}
        </Link>
      )}
    </li>
  )
}
